import React from "react"
import { CircularProgress, Container, Stack } from "@mui/material"
import { Inventory2Outlined } from "@mui/icons-material"
import { Typography } from "@mui/material"

const LoadingListings: React.FC = () => (
  <Container maxWidth={false}>
    <Stack alignItems="center" justifyContent="center" minHeight={300}>
      <CircularProgress />
    </Stack>
  </Container>
)

const EmptyListings: React.FC = () => (
  <Container maxWidth={false}>
    <Stack alignItems="center" justifyContent="center" minHeight={300} gap={2}>
      <Inventory2Outlined sx={{ fontSize: 56, color: "text.disabled" }} />
      <Typography variant="h6" color="text.secondary">
        No listings yet
      </Typography>
      <Typography variant="body2" color="text.disabled">
        Products you generate with AI will appear here.
      </Typography>
    </Stack>
  </Container>
)

export { LoadingListings, EmptyListings }
